const skills = [
    {
        name: "Java",
        level: 4,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg"
    },
     {
        name: "Kotlin",
        level: 4,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg"
    },
    {
        name: "Android Kotlin/Java",
        level: 4,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg"
    },
    {
        name: "Jetpack Compose",
        level: 2,
        image: "https://cdn.jsdelivr.net/gh/getvmio/getvm-icons@master/logos/jetpackcompose.svg"
    },
    {
        name: "Firebase",
        level: 4,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg"
    },
    {
        name: "Springboot",
        level: 2,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg"
    },
    {
        name: "React.JS",
        level: 4,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
    },
     {
        name: "Tailwind",
        level: 4,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg"
    },

    {
        name: "HTML",
        level: 4,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
    },
    {
        name: "CSS",
        level: 4,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
    },
    {
        name: "JavaScript",
        level: 3,
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
    },
    
    
];

export default skills;